

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ChildPlace_ManagedObject

class ChildPlace_ManagedObject extends CoreEntityUpdatedBy
{
}
